import * as React from 'react';
import { Utils } from '../../../utils';
import { RHFInputText, RHFInputTextProps } from './input-text';

export function RHFInputTextNullable(props: RHFInputTextProps) {
  return <RHFInputText {...props} setValueAs={Utils.normalizeString} />;
}
